'use strict';

var _ = require('lodash');

function transposeMatrix(a) {
    var w = a.length || 0;
    var h = a[0] instanceof Array ? a[0].length : 0;
    if (h === 0 || w === 0) {
        return [];
    }
    var i,
        j,
        t = [];
    for (i = 0; i < h; i++) {
        t[i] = [];
        for (j = 0; j < w; j++) {
            t[i][j] = a[j][i];
        }
    }
    return t;
}

function setDynamicHeight($container) {
    if (!$container && $container.length === 0) {
        return;
    }

    var matrix = [];

    // Reset child height
    $container.each(function (i, container) {
        $(container).children().each(function (j, child) {
            $(child).css('height', '');
        });
    });

    // Generate height matrix
    $container.each(function (i, container) {
        matrix[i] = [];
        $(container).children().each(function (j, child) {
            matrix[i][j] = $(child).height();
        });
    });

    // Transpose matrix
    var transposedMatrix = transposeMatrix(matrix);
    var maxHeights = [];

    // Save max height for each element
    for (var k = 0; k < transposedMatrix.length; k++) {
        maxHeights[k] = Math.max(...transposedMatrix[k]);
    }

    // Set max height for each element
    $container.each(function (i, container) {
        $(container).children().each(function (j, child) {
            $(child).height(maxHeights[j]);
        });
    });
}

/**
 * Returns the maximum height of a set of elements
 * @param {jQuery} $elements - the set of elements to measure
 * @returns {number} - the maximum height of the elements
 */
function getMaxHeight($elements) {
    if ($elements.length === 0) {
        return 0;
    }

    return Math.max.apply(null, $elements.map(function () {
        return $(this).height();
    }).get());
}

module.exports = {
    setDynamicHeight: function () {
        var _this = this;
        var $dynamicHeight = $('.js-dynamic-height');
        var $window = $(window);
        var windowWidth = $window.width();

        setDynamicHeight($dynamicHeight);

        $window.resize(_.debounce(function () {
            if ($window.width() != windowWidth) {
                windowWidth = $window.width();
                setDynamicHeight($dynamicHeight);
                _this.alignTiles(true);
            }
        }, 200));

        $window.on('alignTiles', function (e, data) {
            if (data && data.container && $(data.container).length > 0) {
                var $container = $(data.container);
                setTimeout(() => {
                    _this.alignTileContent($container, data.resetHeight || false);
                }, 0);
            } else {
                _this.alignTiles(false);
            }
        });
    },
    alignTiles: function (resetHeight) {
        var _this = this;
        var $containers = $('.js-align-tiles');

        if ($containers.length === 0) {
            return;
        }

        $containers.each(function (i, container) {
            var $container = $(container);

            // To be called at the end of the stack
            setTimeout(() => {
                _this.alignTileContent($container, resetHeight);
            }, 0);
        });
    },
    alignTileContent: function ($container, resetHeight) {
        if (!$container || $container.length === 0) {
            return;
        }

        var $badges = $container.find('.js-align-badge');
        var $productNames = $container.find('.js-align-name');
        var $categoryNames = $container.find('.js-align-category');
        var $prices = $container.find('.js-align-price');
        var $callouts = $container.find('.js-align-callout');
        var $tilesFooter = $container.find('.js-align-footer');

        if (resetHeight) {
            $badges.css('height', 'auto');
            $badges.css('min-height', 'auto');

            $productNames.css('height', 'auto');
            $productNames.css('min-height', 'auto');

            $categoryNames.css('height', 'auto');
            $categoryNames.css('min-height', 'auto');

            $prices.css('height', 'auto');
            $prices.css('min-height', 'auto');

            $callouts.css('height', 'auto');
            $callouts.css('min-height', 'auto');

            $tilesFooter.css('height', 'auto');
            $tilesFooter.css('min-height', 'auto');
        }

        $badges.css('height', getMaxHeight($badges));
        $badges.css('min-height', getMaxHeight($badges));

        $productNames.css('height', getMaxHeight($productNames));
        $productNames.css('min-height', getMaxHeight($productNames));

        $categoryNames.css('height', getMaxHeight($categoryNames));
        $categoryNames.css('min-height', getMaxHeight($categoryNames));

        $prices.css('height', getMaxHeight($prices));
        $prices.css('min-height', getMaxHeight($prices));

        $callouts.css('height', getMaxHeight($callouts));
        $callouts.css('min-height', getMaxHeight($callouts));

        $tilesFooter.css('height', getMaxHeight($tilesFooter));
        $tilesFooter.css('min-height', getMaxHeight($tilesFooter));
    }
};

